import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchInviteTemplatesAction } from "redux/actions/fetchInviteTemplatesAction";
import Loading from "shared/components/Loading";
import { useTranslation } from "react-i18next";
import OrganisationItem from "../../components/OrganisationItem";
import TemplateItem from "../../components/TemplateItem";
import { sortByOrderType } from "helpers/sortByOrderType";
import ListHeader from "components/ListHeader";
import Button from "shared/components/buttons/Button";
import { ICONS } from "shared/components/Icon";
import "./style.scss";

export default function InvitationTemplates() {

    const [t] = useTranslation();

    const dispatch = useDispatch();

    const [active, setActive] = useState(false);
    const [sortIndex, setSortIndex] = useState(0);
    const [sortDirection, setSortDirection] = useState(false);

    useEffect(() => {
        dispatch(fetchInviteTemplatesAction());
    }, [dispatch]);
    const { inviteTemplates, loading } = useSelector(state => state.invite);
    

    const hasTemplates = () => {
        return Array.isArray(inviteTemplates) && inviteTemplates.length > 0;
    };

     const sortItems = (items) => {
            return Array.isArray(items) && items.length > 0 && sortIndex >= 0
                ? sortByOrderType(HEADERS, items, sortIndex, sortDirection)
                : items;
        };
    const HEADERS = [
        { field: "label", label: t("audit.book.singular") },
        { field: "numberOfBranches", label: t("book.edit.invitation.approval.status") },
        { field: "numberOfUsers", label: t("book.edit.invitation.approval.message") }
    ];


    const onSort = (idx) => {
        setSortDirection(!sortDirection);
        setSortIndex(idx);
    };

    const renderEmptyState = () => {
        return (
            <div className="container-empty">
                {t("admin.templates.empty")}
            </div>
        );
    };

     const renderTemplateItems = () => {
            const sortedItems = sortItems(inviteTemplates);
            return sortedItems.map((item, index) => {
                return (
                    <TemplateItem
                        key={index}
                        index={index}
                        item={item}
                    />
                );
            });
        };

    const renderTemplates = () => {
        if (hasTemplates()) {
            return renderTemplateItems();
        } else if (!loading) {
            return renderEmptyState();
        }
    };

    const renderListHeader = () => {
        return Array.isArray(inviteTemplates) && inviteTemplates.length > 0 && (
            <ListHeader onSort={onSort}
                items={HEADERS}
                sortIndex={sortIndex}
                sortDirection={sortDirection}
            />);
    };

    return (
        <div className="organisation-overview">
            {!active &&
                <div className="overview-header">
                    <h2>{t("admin.templates.title")}</h2>
                </div>}

            <div className="spacer" />
            <div className="filter-divider" />
            <div className="spacer-double" />

            {loading ?
                <Loading /> :
                <>
                    {renderListHeader()}
                    <div className="organisation-list-items">
                    {renderTemplates()}
                    </div>
                </>
            }
        </div>
    );

}